import styled from 'styled-components';

const ChapterBoxWrapper = styled.div`
  z-index: 10;
  width: 100%;
  .half-checked {
    input[type='checkBox'] {
      &:checked {
        background-color: ${({ theme }) => theme.colors.dark[25]};
        border: none;
      }
    }
  }
  .button-text {
    span {
      text-align: start;
    }
  }

  .chapter-name-box {
    .trash-icon {
      background-color: inherit;
      visibility: hidden;
    }

    &:hover {
      .trash-icon {
        visibility: visible;
      }
    }
  }

  .chapter-textarea {
    width: 100%;
    form {
      width: 100%;
      max-width: 260px;
    }
    .input-content {
      display: flex;
      align-items: center;
      textarea {
        resize: none;
        min-height: 20px;
        height: auto;
        min-width: 100%;
        font-size: 16px;
        font-weight: 500;
        line-height: 24px;
        color: ${({ theme }) => theme.colors.dark[100]};
        background-color: inherit;
        border: none;
        padding: 0;
      }
    }
  }
`;

export default ChapterBoxWrapper;
